import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { twix } from 'tailwindcss-radix-ui';
import { PiCaretDownBold } from 'react-icons/pi';

export const Root = DropdownMenu.Root;
export const Portal = DropdownMenu.Portal;
export const Group = DropdownMenu.Group;
export const Label = DropdownMenu.Label;

export const Trigger = twix(
  DropdownMenu.Trigger,
  'flex items-center gap-2 rounded-md border border-brand bg-brand/10 py-1 pl-4 pr-2',
);

export const TriggerIcon = ({ size = 20 }: { size?: number }): JSX.Element => (
  <PiCaretDownBold size={size} />
);

export const Content = twix(
  DropdownMenu.Content,
  'brand right-0 z-20 mt-2 space-y-2 rounded bg-violet-darker p-2 pt-4 shadow-[2px_4px_8px_0_rgba(0,0,0,0.24)] radix-state-closed:animate-slide-up-fade-out radix-state-open:animate-slide-down-fade-in',
);

export const Item = twix(
  DropdownMenu.Item,
  'relative flex cursor-pointer select-none items-start gap-2 rounded-sm px-2 py-[0.4rem] font-primary-light text-base outline-none hover:bg-brand/30 focus:bg-brand/50',
);

export const Separator = twix(DropdownMenu.Separator, 'my-2 border border-gray-70');
